import { hostsConfig } from 'init/config'
import { IUserState } from 'init/global-store'

export const MODERATION_URL = `${hostsConfig.protocol}://${hostsConfig.moderationHost}`

/**
 * Used for service calls that are passing an array on the path
 * @param arr
 */
export function encodeArray(arr) {
  return Array.isArray(arr) && arr.length > 0 ? encodeURIComponent(arr.join(',')) : '_ALL_'
}

export function getProductImageUrl(catItem, size = 'L', siblingSiteKey?: string) {
  const imgSiteKey = siblingSiteKey || hostsConfig.siteKey
  return `${hostsConfig.protocol}://${hostsConfig.imageStoreBase}/item/${imgSiteKey}/` +
    `${catItem.imageId}${size}.png`
}

type TurnToConfigObj = 'chatter' | 'commentCapture' | 'commentsPinboard' |
                       'commentsPinboardTeaser' | 'instantAnswers' | 'gallery' | 'qa' |
                       'relatedReviews' | 'reviewsList' | 'reviewsSummary' | 'spectrum' |
                       'subdimensionTeaser' | 'teaser' | 'topComments' | 'userToolbar' |
                       'vcPinboard'

export function callTurnToConfigFn(objName: TurnToConfigObj, fnName: string) {
  const objConfig = window.turnToConfig[objName] || {}
  // if client provided the function
  if (objConfig[fnName]) {
    objConfig[fnName]()
  }
}


interface TTData {
  u?: number // user.id
  f?: string // user.firstName
  l?: string // user.lastName
  n?: string // user.nickName
  m?: boolean // user.isModerator
  c?: number // catItemId
}

export const TTDAT_PARAM_NAME = 'ttdat'

export interface AdditionalFlowData {
  user?: IUserState
  catItemId?: number
}

export function parseTTdat(ttdat: string): AdditionalFlowData {
  let data = {} as AdditionalFlowData
  if (ttdat) {
    // Base64 encoded JSON data (user, catItemId, etc)
    const parsedTTdat = JSON.parse(atob(ttdat)) as TTData
    data = {
      user: !parsedTTdat.u ? null : {
        id: parsedTTdat.u,
        firstName: parsedTTdat.f,
        lastName: parsedTTdat.l,
        nickName: parsedTTdat.n,
        isModerator: parsedTTdat.m || false
      },
      catItemId: parsedTTdat.c
    }
  }
  return data
}

/**
 * Utility to retrieve int value from sessionStorage
 * @param type
 * @param id
 */
export function getSessionVarInt(type, id) {
  if (window.sessionStorage.getItem(`${type}_${id}`)) {
    return parseInt(window.sessionStorage.getItem(`${type}_${id}`))
  }
  return null
}

export function getSessionVar(type, id) {
  return window.sessionStorage.getItem(`${type}_${id}`)
}

export function removeSessionVar(type, id) {
  window.sessionStorage.removeItem(`${type}_${id}`)
}

export function setSessionVar(type, id, value) {
  window.sessionStorage.setItem(`${type}_${id}`, value)
}
